import React from 'react';
import { MapPin } from 'lucide-react';

const keywords = [
  'Intraday Trading',
  'Swing Trading',
  'NIFTY Options',
  'Bank NIFTY',
  'Price Action',
  'Chart Patterns',
  'RSI / MACD',
  'Option Greeks',
  'Iron Condor',
  'Risk Management',
  'NSE Trading',
  'Trading Psychology',
];

const SEOContent = () => {
  return (
    <section className="py-16 sm:py-20 bg-white" data-testid="seo-content-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-1.5 bg-green-100 text-green-800 px-3.5 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-4">
            <MapPin className="h-3.5 w-3.5" />
            About the Academy
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-5 leading-tight">
            Bhopal's Trusted <span className="text-green-600">Stock Market Training</span> Institute
          </h2>

          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
            <strong>Stocks Vision Academy</strong> is one of the leading stock market training institutes in
            Bhopal — based in MP Nagar and personally led by <strong>Deepak Singhai</strong>, a NISM Certified
            Research Analyst (RA). We specialise in practical stock trading education, technical analysis,
            and options trading courses for beginners as well as experienced traders.
          </p>

          <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
            Our focus is execution — not theory. Every student learns through real-time NSE charts, live
            market sessions, and disciplined risk management, in small focused batches that ensure genuine
            personal mentorship.
          </p>

          <div className="mt-10">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Topics covered across our two flagship courses</h3>
            <div className="flex flex-wrap gap-2">
              {keywords.map((k) => (
                <span
                  key={k}
                  className="inline-block bg-green-50 border border-green-200 text-green-800 text-sm font-medium px-3 py-1.5 rounded-lg"
                >
                  {k}
                </span>
              ))}
            </div>
            <p className="text-sm text-gray-500 mt-4">
              Detailed course curriculum and fees → <a href="#courses" className="text-green-600 font-semibold hover:underline">Our Courses</a> · Visit us → <a href="#location" className="text-green-600 font-semibold hover:underline">Location & Directions</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SEOContent;
